import React from "react";
import LinearLoader from "../../Loader/LinearLoader";
import './styles.css';

function PhoneNumberConfirmationForm({ phoneNumber, loading }) {

    const handleSendSMS = () => {
        // Adicione a lógica para enviar o SMS aqui
        console.log("SMS enviado para:", phoneNumber);
        // Navegue para a próxima tela ou exiba uma mensagem de sucesso
    };

    return (
        <div className="phone-number-confirmation-container">
            <h1>Confirmação de Telefone</h1>
            <div className="phone-number-card">
                <div className="phone-number-form-container">
                    <p className="phone-number-form-title">Verificação de Telefone</p>
                    <p className="phone-number-form-subtitle">Seu número de telefone é: {phoneNumber}</p>
                    <p className="phone-number-form-text">Enviaremos um código de verificação para este número.</p>
                    <button type="button" className="phone-number-form-button" onClick={handleSendSMS}>
                        {loading ? <LinearLoader white /> : <p>Enviar SMS</p>}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PhoneNumberConfirmationForm;
